import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import {
  MAX_PAGE, LOADING_PAGE, QR_PAGE, ASSET_BUNDLE_PAGE,
} from './pages';

import { actions } from './actions';

/* ------------- New product form reducer ------------- */
const defaultState = {
  product: null,
  qr: null,
  page: 0,
  error: null,
  creating: false,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.CHANGE_PAGE: {
      return state.merge({
        // Limit page to be between [0, MAX_PAGE]
        page: Math.min(MAX_PAGE, Math.max(0, action.payload.page + 1)),
      });
    }
    case actions.SET_INFO: {
      return state.merge({
        product: action.payload.product,
      });
    }
    case actions.NEXT_PAGE: {
      return state.merge({
        // Limit page to be between [0, MAX_PAGE]
        page: Math.min(MAX_PAGE, Math.max(0, state.page + 1)),
      });
    }
    case actions.PREV_PAGE: {
      return state.merge({
        // Limit page to be between [0, MAX_PAGE]
        page: Math.min(MAX_PAGE, Math.max(0, state.page - 1)),
      });
    }
    case actions.START_CREATION: {
      return state.merge({ page: LOADING_PAGE, creating: true });
    }
    case actions.END_CREATION_SUCCESS: {
      const { product, qr } = action.payload;
      return state.merge({
        product,
        qr,
        error: null,
        creating: false,
        page: QR_PAGE,
      });
    }
    case actions.END_CREATION_FAIL: {
      return state.merge({
        product: null,
        qr: null,
        creating: false,
        error: action.payload.error,
        page: state.page - 1,
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- New product form propTypes ------------- */
export const propTypes = {
};



// WEBPACK FOOTER //
// ./src/redux/NewProductForm/reducer.js